var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack430({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.21,12.78V6.24H4.88V4.91h6.25V6.24H8.8v6.54Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack430);
export default __webpack_public_path__ + "static/media/Symbolpack_4_30.40e2d8471c51479cd7a8a01c2d2c5b61.svg";
export { ForwardRef as ReactComponent };